/**
 * UI/UX's prototype mode in the style bar: where a click on the selected element leads
 * (`#board-navigate`) and how (`#board-transition`), or for a screen "Start here".
 */
import { For, Show, type JSX } from "solid-js";
import { useApp, usePack } from "../../../app/context";
import type { Bar } from "../../../state/board";
import { TRANSITIONS } from "../prototype";
import type { UiUx } from "../service";

/** Where a click leads, or the screen played first. */
export function PrototypeTools(props: { bar: Bar }): JSX.Element {
  const { board } = useApp();
  const uiux = usePack<UiUx>("uiux");
  const { shape, value } = props.bar;
  return (
    <Show
      when={shape() !== "frame"}
      fallback={
        <Show when={uiux.screens().some((f) => f.id === board.selected()[0])}>
          <button type="button" data-board-action="start" aria-pressed={value("start") === "yes"} onClick={() => void uiux.makeStart()}>
            ▶ Start here
          </button>
        </Show>
      }
    >
      <label class="board-field">
        On click, go to
        <select id="board-navigate" value={value("navigate")} onChange={(e) => void Promise.all(board.selected().map((id) => uiux.lead(id, e.currentTarget.value)))}>
          <option value="">nowhere</option>
          <option value="back">the screen before</option>
          <For each={uiux.screens()}>{(f) => <option value={f.id}>{f.group.name}</option>}</For>
        </select>
      </label>
      <Show when={value("navigate")}>
        <select
          id="board-transition"
          aria-label="Transition"
          value={value("transition") || "instant"}
          onChange={(e) => void board.setStyle("transition", e.currentTarget.value === "instant" ? "" : e.currentTarget.value)}
        >
          <For each={TRANSITIONS}>{(t) => <option value={t}>{t}</option>}</For>
        </select>
      </Show>
    </Show>
  );
}
